export default __webpack_public_path__ + "static/media/friends_at_venice_beach.a2206a3e.jpg";